import { Outlet, createFileRoute } from '@tanstack/react-router';
import { guardWorkspaceShell } from '../../../router/route-utils';

export const Route = createFileRoute('/_authenticated/w/$workspaceSlug')({
  staticData: {
    pageName: '',
    isPathless: false,
  },
  beforeLoad: async ({ context, params, location }) => {
    await guardWorkspaceShell(context, params.workspaceSlug, location);
  },
  component: WorkspaceShellLayout,
});

function WorkspaceShellLayout() {
  return <Outlet />;
}
